/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2021-03-23 10:04:09
 * @LastEditors: sjq
 * @LastEditTime: 2021-12-13 11:22:00
 */

// <el-input v-model="formData.value" v-number="{maxNum: 1, lastPoint: 2, prop: formData, propName: 'value'}"/>
// 限制最大值 / 最小值
// 限制最大长度 / 最小长度
// 限制小数点后可以输入几位数字

function MaxNum(prop, propName, e, num) {
  if (num < Number(e.target.value)) prop[propName] = e.target.value = String(num)
}

function MinNum(prop, propName, e, num) {
  if (num >= Number(e.target.value)) prop[propName] = e.target.value = num
}

function MaxLong(prop, propName, e, num) {
  if (num < String(e.target.value).length) {
    prop[propName] = e.target.value = String(e.target.value).substring(0, num)
  } else {
    prop[propName] = e.target.value
  }
}

function MinLong(prop, propName, e, num) {
  if (num > String(e.target.value).length) prop[propName] = e.target.value = String(e.target.value).substring(0, num)
}

function Point(prop, propName, e, lastPoint, eVal) {
  if (eVal.indexOf('.') !== -1) {
    // 小数点前面的数字
    const fristNumber = eVal.substring(0, eVal.indexOf('.') + 1)
    if (lastPoint === 0) {
      prop[propName] = e.target.value = eVal.substring(0, eVal.indexOf('.'))
    }
    // 小数点后面的数字
    const lastNumber = String(eVal).substring(String(eVal).indexOf('.') + 1)
    if (lastNumber.length > lastPoint) {
      prop[propName] = e.target.value = fristNumber + lastNumber.substring(0, lastPoint)
    }
  }
}

export const number = {
  inserted(el, { value }) {
    el.addEventListener('input', function (e) {
      let eVal = e.target.value
      let nowVal = eVal.substring(eVal.length - 1)
      /**
       * value
       * @private {Object} 传入的值
       * @param {Object} prop 改变值的对象
       * @param {String} propName 改变值的字段名
       * @param {Number} lastPoint 保留小数点后几位
       * @param {Number} maxNum 最大输入
       * @param {Number} minNum 最小输入
       * @param {Number} maxLong 最大长度
       * @param {Number} minLong 最小长度
       */
      let { prop, propName, minNum, maxNum, maxLong, minLong, lastPoint } = value
      e = e || window.event
      let charcode = e.data
      let re = /\d|\./
      // console.log(e, e.data, 'input', !re.test(charcode))
      if (!re.test(charcode)) {
        prop[propName] = e.target.value = isNaN(e.target.value * 1) ? 0 : e.target.value
        return
      }

      // 不能输入 如 00.11
      if (nowVal === '0' && eVal[0] === '0' && eVal[1] !== '.' && eVal.length > 1) {
        prop[propName] = e.target.value = eVal.substring(1, eVal.length)
        return
      }
      eVal = eVal * 1 + ''
      // prop[propName] = e.target.value = eVal * 1
      // 输入的是点或者数字允许进入规则校验 反之删除
      if ((nowVal === '.' || !isNaN(nowVal)) && !isNaN(eVal)) {
        if (minNum !== undefined && MinNum(prop, propName, e, minNum)) return
        if (maxNum !== undefined && MaxNum(prop, propName, e, maxNum)) return
        if (minLong !== undefined && MinLong(prop, propName, e, minLong)) return
        if (maxLong !== undefined && MaxLong(prop, propName, e, maxLong)) return
        lastPoint !== undefined && Point(prop, propName, e, lastPoint, eVal)
      } else {
        prop[propName] = e.target.value = eVal.substring(0, eVal.length - 1) * 1
      }
    })
  }
}
